export default __webpack_public_path__ + "static/media/Spring_Drapes_Btn.8977deab.jpg";